var SplitPane = require('./lib/SplitPane');

module.exports = SplitPane;


//////////////////
// WEBPACK FOOTER
// ./~/react-split-pane/index.js
// module id = 1055
// module chunks = 0